import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { EventType } from "pages/statuses/EventType";
import { DateUtil } from "utilities/DateUtil";
import { BOOKING_TYPE_ID_DEPOSIT } from "utilities/DbValueConstants";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        table: {
            color: `black`,
            tableLayout: `fixed`,
            border: `1px solid`,
            fontWeight: `normal`,
            textAlign: `center`,
            width: `100%`,
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(3),
        },
    })
);

interface Props {
    // 予約情報
    booking: EventType;
}

/**
 * 予約確認事項コンポーネント
 */
export const BookingConfirmItems: React.FC<Props> = (props) => {
    const { booking } = props;
    const classes = useStyles();
    const isDepositMode = booking.bookingTypeId === BOOKING_TYPE_ID_DEPOSIT;

    const getTypeString = (): string => {
        if (isDepositMode == false) {
            return "廃液";
        }
        return "付着物"
    }

    return (
        <div>
            【予約確認事項】
            <table className={classes.table}>
                <tbody>
                    <tr className={classes.table}>
                        <th className={classes.table} colSpan={2}>
                            {getTypeString()}回収
                        </th>
                    </tr>
                    <tr className={classes.table}>
                        <th className={classes.table}>{getTypeString()}回収日</th>
                        <td>{DateUtil.parseViewDateForDialog(booking.start)}</td>
                    </tr>
                    <tr className={classes.table}>
                        <th className={classes.table}>{getTypeString()}回収時間</th>
                        <td>{DateUtil.parseViewTime(booking.start, booking.end)}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
